<template>
    <div>
        <el-row :gutter="20">
            <el-col :span="8">
                <UploadImg
                    type="enterpriseUserAvatar"
                    :on-success="onSuccessUpload"
                    :src="image"
                />
            </el-col>
            <el-col :span="16">
                <el-form
                    :model="userInfoData"
                    :rules="rules"
                    ref="userInfoForm"
                    label-width="auto"
                >
                    <!-- 所属部门 -->
                    <el-form-item :label="$t('navbar.department')">
                        <span>{{ department }}</span>
                    </el-form-item>
                    <!-- 当前角色 -->
                    <el-form-item :label="$t('navbar.currentRole')">
                        <span>{{ roles.join("/") }}</span>
                    </el-form-item>
                    <!-- 用户名称 -->
                    <el-form-item :label="$t('navbar.userName')">
                        <span>{{ name }}</span>
                    </el-form-item>
                    <!-- 手机号码 -->
                    <el-form-item
                        :label="$t('navbar.mobileNumber')"
                        prop="mobile"
                    >
                        <el-input
                            maxlength="20"
                            v-model="userInfoData.mobile"
                            style="width: 150px"
                        />
                    </el-form-item>
                    <el-form-item>
                        <!-- 取消 -->
                        <el-button @click="cancelHander">{{ $t("public.cancel") }}</el-button>
                        <!-- 确定 -->
                        <el-button
                            type="primary"
                            @click="sureHander"
                        >{{ $t("public.save") }}</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

export default {
    name: "userInfo",

    components: {
        UploadImg: () => import("@/components/UploadImg"),
    },

    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            image: "",
            userInfoData: {
                mobile: "",
            },
            rules: {
                mobile: [
                    {
                        required: true,
                        message: this.$t("navbar.pleaseEnterPhoneNumber"),
                        trigger: "blur",
                    }, // 请输入手机号码
                ],
            },
        };
    },

    mounted() {
        this.userInfoData.mobile = this.mobile;
        this.image = this.avatar;
    },

    computed: {
        ...mapGetters(["name", "roles"]),
        ...mapState({
            department: (state) => state.user.department,
            mobile: (state) => state.user.mobile,
            avatar: (state) => state.user.avatar,
        }),
    },

    methods: {
        cancelHander() {
            this.$emit("update:visible", false);
        },

        sureHander() {
            let userObj = {
                image: this.image,
                mobile: this.userInfoData.mobile,
            };
            this.$emit("updataPersonInfo", userObj);
        },

        onSuccessUpload({ state, data }) {
            if (state === 1) {
                this.image = data;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
